import { render } from "./BillingLayout.vue?vue&type=template&id=6e66f651"
import script from "./BillingLayout.vue?vue&type=script&lang=js"
export * from "./BillingLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__